import '../css/tailwind.css';

import { create as createMenu } from "./components/menu";

document.addEventListener('DOMContentLoaded', () => {
    createMenu();
});